module.exports = __webpack_public_path__ + "img/安新制鞋.1f2f29f7.jpg";